
import "../../../../App.scss";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import Avatar from "react-avatar";
import { WPSearch } from "../renderers/ActionRenderers/WPSearchRenderer";
import { PMItemGroup } from "../renderers/ActionRenderers/PMItemGroup";
import { getTrainingSts, getDefaultDate, formatDateDDMMYYYY, formatDateDD_MM_YYYY } from "../../../../functions/welding-functions";
import { ICONS } from "../../common/constants/icons"; ////common svg file
import { createDropdown, refreshDropdown } from "../../common/DropdownComponent/DropdownHelper";
import { useEffect } from "react";
import { ProdSelectDropdown } from "../../common/TransactionComponents/TransactionEntity";

const GlobalColumnDefinations = (tmpcolumnDefs) => {
  let coldefs = [];
  const todayDate = getDefaultDate();
  const filterDate = {
    comparator: (filterLocalDateAtMidnight, cellValue) => {
      const dateAsString = formatDateDD_MM_YYYY(cellValue);
      if (dateAsString === null) {
        return 0;
      }
      const dateParts = dateAsString.split("-");
      const year = Number(dateParts[2]);
      const month = Number(dateParts[1]) - 1;
      const day = Number(dateParts[0]);
      const dateCell = new Date(year, month, day);

      if (dateCell < filterLocalDateAtMidnight) {

        return -1;
      } else if (dateCell > filterLocalDateAtMidnight) {

        return 1;
      }
      return 0;
    },
  };


  const AvatarCellRenderer = (props) => {
    console.log("props.value:", props.value);
    const colors = ["avatarcolor1", "avatarcolor2", "avatarcolor3"];
    const index = props.rowIndex;
    const colorIndex = index % colors.length;
    const selectedColor = colors[colorIndex];

    // Handle array properly
    const displayName = Array.isArray(props.value) ? props.value.join(", ") : props.value;

    return (
      <>
        <Avatar
          className={selectedColor}
          maxInitials={2}
          name={displayName} // initials from combined string
          round={true}
          size="35"
        />
        &nbsp;&nbsp;
        <span>{displayName || ""}</span>
      </>
    );
  };


  const PWHTcheckbox = (props) => {
    return (
      <span>{props?.data?.CheckboxPostWHT === true ? "yes" : "no"}</span>
    );
  };

  const statusRenderer = (params) => {
    let st = params.value;
    let statusimage = st === "Active" ? ICONS.CorrectSign : ICONS.WrongSign;
    let classname = st === "Active" ? 'status-color-active' : 'status-color-inactive';
    return (
      <span className={classname}>
        <img
          src={statusimage}
          alt={st}
        />
        {st}
      </span>
    );
  };

  const Editor = (type) => {
    if (type === "WPSearch")
      return {
        component: WPSearch,
      };

    if (type === "PRODSelect") {
      //get the latest dropdown values for WC in Kgs/Nos dropdown value master
      refreshDropdown("WC in Kgs/Nos");
      return {
        component: "agSelectCellEditor",
        params: {
          values: ProdSelectDropdown.map((item) => item.value),
        },
      };
    }
    if (type === "ItemGroup")
      return {
        //component: "agSelectCellEditor",
        component: PMItemGroup,

      };
  };

  const ErrorCss = (error) => {

    if (error === true) {
      return { "rag-amber": (params) => params.data.hasError === true };
    }
  };

  const STATUS_CONFIGS = {
    training: {
      "In Progress": { status_color: "var(--godrej-orange)", bk_color: "var(--godrej-orange-bg)" },
      "Upcoming": { status_color: "var(--godrej-blue)", bk_color: "var(--godrej-blue-bg)" },
      "Completed": { status_color: "var(--godrej-green-alt)", bk_color: "var(--godrej-green-bg)" }
    },
    raise: {
      "Pending for CAPA Analysis": { status_color: "var(--godrej-orange)", bk_color: "var(--godrej-orange-bg)", width: "4.4cm" },
      "Pending for Closure": { status_color: "var(--godrej-blue)", bk_color: "var(--godrej-blue-bg)", width: "3.4cm" },
      "Closed": { status_color: "var(--txt-color)", bk_color: "var(--bg-alt-2)", width: "1.4cm" },
      "Rejected": { status_color: "var(--godrej-red)", bk_color: "var(--godrej-red-bg)", width: "1.7cm" }
    },
    trainingReq: {
      "Initiated": { status_color: "var(--godrej-orange)", bk_color: "var(--godrej-orange-bg)", width: "140px" },
      "In Progress": { status_color: "var(--godrej-orange)", bk_color: "var(--godrej-orange-bg)", width: "140px" },
      "Approved": { status_color: "var(--godrej-blue)", bk_color: "var(--godrej-blue-bg)", width: "140px" },
      "Rejected": { status_color: "var(--godrej-red)", bk_color: "var(--godrej-red-bg)", width: "140px" },
      "Deleted": { status_color: "var(--godrej-red)", bk_color: "var(--godrej-red-bg)", width: "140px" }
    },
    wps: {
      "Temporary Saved": { status_color: "var(--godrej-orange)", bk_color: "var(--godrej-orange-bg)", multiplier: 11.5 },
      "Pending For Approval": { status_color: "var(--godrej-blue)", bk_color: "var(--godrej-blue-bg)", multiplier: 10 },
      "Approved": { status_color: "var(--godrej-green-alt)", bk_color: "var(--godrej-green-bg)", multiplier: 15 },
      "Rejected": { status_color: "var(--godrej-red)", bk_color: "var(--godrej-red-bg)", multiplier: 15 },
      "Freezed": { status_color: "var(--godrej-red)", bk_color: "var(--godrej-red-bg)", multiplier: 15 }
    },
    weldRepair: {
      "In Progress": { status_color: "var(--godrej-orange)", bk_color: "var(--godrej-orange-bg)", multiplier: 12 },
      "Pending for Proposal Status": { status_color: "var(--godrej-blue)", bk_color: "var(--godrej-blue-bg)" },
      "Created": { status_color: "var(--godrej-green-alt)", bk_color: "var(--godrej-green-bg)", multiplier: 15 },
      "Approved": { status_color: "var(--godrej-green-alt)", bk_color: "var(--godrej-green-bg)", multiplier: 15 },
      "Rejected": { status_color: "var(--godrej-red)", bk_color: "var(--godrej-red-bg)", multiplier: 15 },
      "Closed": { status_color: "var(--godrej-red)", bk_color: "var(--godrej-red-bg)", multiplier: 15 }
    }
  };

  const createStatusRenderer = (configType, statusGetter) => (params) => {
    const status = statusGetter ? statusGetter(params) : params.value;
    const config = STATUS_CONFIGS[configType][status];
    if (!config) return <span>{status}</span>;

    const width = config.width || (config.multiplier ? `${status.length * config.multiplier}px` : "auto");

    return (
      <div
        style={{
          backgroundColor: config.bk_color,
          borderRadius: "4px",
          height: "24px",
          marginTop: "12px",
          width
        }}
        className="d-flex align-items-center"
      >
        <span style={{ color: config.status_color, marginLeft: "20px" }}>
          &nbsp;{status}&nbsp;
        </span>
      </div>
    );
  };

  const trainingCellRenderer = createStatusRenderer('training', (params) =>
    getTrainingSts(params.data.wld_fromDate, params.data.wld_toDate, todayDate)
  );

  const RaiseCellRenderer = createStatusRenderer('raise', (params) => params.data.devstatus);

  const trainingReqCellRenderer = createStatusRenderer('trainingReq', (params) => {
    const status = params.data.wld_status;
    return (status === "In Progress" || status === "In_Progress") ? "In Progress" : status;
  });

  const WPSCellRenderer = createStatusRenderer('wps');

  const PQRSrno = (params) => params.node.rowIndex + 1;

  const WeldRepairRenderer = createStatusRenderer('weldRepair');

  const dateCellRenderer = (params) => {
    return formatDateDDMMYYYY(params.value);
  };

  const getFilterParam = (filter) => {
    if (filter === "filterDate") {
      return filterDate;
    }
  };

  const cellRendererMap = {
    AvatarCellRenderer,
    statusRenderer,
    trainingCellRenderer,
    trainingReqCellRenderer,
    RaiseCellRenderer,
    WPSCellRenderer,
    PQRSrno,
    WeldRepairRenderer,
    dateCellRenderer,
    WPSearch,
    PWHTcheckbox
  };

  const getCellRenderer = (type) => cellRendererMap[type] || null;

  const filterTypeMap = {
    Text: "agTextColumnFilter",
    Number: "agNumberColumnFilter",
    Date: "agDateColumnFilter"
  };

  const getfiltertype = (type) => filterTypeMap[type] || "agTextColumnFilter";

  const contains = (target, lookingFor) => {
    return target && target.startsWith(lookingFor);
  };

  if (Array.isArray(tmpcolumnDefs)) {
    for (const tmpcolumnDef of tmpcolumnDefs) {

      let tmpheadername = tmpcolumnDef["headerName"];
      if (tmpheadername != "Status") {
        coldefs.push({
          field: tmpcolumnDef["field"],
          cellRenderer: getCellRenderer(tmpcolumnDef["cellRenderer"]),
          resizable: true,
          headerName: tmpcolumnDef["headerName"],
          filter: getfiltertype(tmpcolumnDef["type"]),
          tooltipField: tmpcolumnDef["field"],
          width: tmpcolumnDef["width"],
          headerwidth: tmpcolumnDef["width"],
          headerCheckboxSelection: tmpcolumnDef["isCheckbox"],
          checkboxSelection: tmpcolumnDef["isCheckbox"],
          suppressSizeToFit: tmpcolumnDef["suppressSizeToFit"],
          flex: tmpcolumnDef["flex"],
          minWidth: tmpcolumnDef["minWidth"],
          sort: tmpcolumnDef["sort"],
          pinned: tmpcolumnDef["pinned"],
          suppressFilter: tmpcolumnDef["suppressFilter"],
          floatingFilter: tmpcolumnDef["floatingFilter"],
          floatingFilterComponentParams:
            tmpcolumnDef["floatingFilterComponentParams"],
          suppressFilterButton: tmpcolumnDef["suppressFilterButton"],

          suppressMenu: tmpcolumnDef["suppressMenu"],
          suppressSort: tmpcolumnDef["suppressSort"],

          filterParams: getFilterParam(tmpcolumnDef["filterParams"]),
          cellStyle: tmpcolumnDef["cellStyle"],
          cellClass: tmpcolumnDef["cellClass"],
          editable:
            tmpcolumnDef["editable"] === "dependentField"
              ? (params) => {
                return editableProd(params);
              }
              : tmpcolumnDef["editable"],

          cellEditorSelector: (params) => Editor(tmpcolumnDef["type"]),
          cellClassRules: ErrorCss(tmpcolumnDef["Error"]),
          valueGetter: tmpcolumnDef["valueGetter"]
            ? (params) => {
              return calculateValue(params);
            }
            : "",

          valueSetter: tmpcolumnDef["valueSetter"]
            ? (params) => {
              return calculateValueSet(params);
            }
            : "",
        });
      } else {
        coldefs.push({
          field: tmpcolumnDef["field"],
          cellRenderer: getCellRenderer(tmpcolumnDef["cellRenderer"]),
          cellStyle: tmpcolumnDef["cellStyle"] || { paddingLeft: 0, alignItems: "center" },
          headerName: tmpcolumnDef["headerName"],
          cellClass: tmpcolumnDef["cellClass"],
          filter: getfiltertype(tmpcolumnDef["type"]),
          sort: tmpcolumnDef["sort"],
          minWidth: tmpcolumnDef["minWidth"],
          sortable: tmpcolumnDef["sortable"],
          filterParams: {
            filterOptions: ["equals"],
            suppressAndOrCondition: true,
            textMatcher: ({ value, filterText }) => {
              let filterTextLowerCase = filterText
                ? filterText.toLowerCase()
                : "";
              let valueLowerCase = value.toString().toLowerCase();
              return contains(valueLowerCase, filterTextLowerCase);
            },
          },
          width: 130,
        });
      }
    }
  }

  return coldefs;
};

const getHeader_FieldName = (field, tmpcolumnDefs, type) => {
  let name = "No match found";
  if (type === "getHeader") {
    let index = tmpcolumnDefs.map((o) => o.field).indexOf(field);
    if (index >= 0) {
      name = tmpcolumnDefs[index].headerName;
    }
  }
  if (type === "getField") {
    let index = tmpcolumnDefs.map((o) => o.headerName).indexOf(field);
    if (index >= 0) {
      name = tmpcolumnDefs[index].field;
    }
  }
  return name;
};

const editableProd = (params) => {
  let fieldname = params.colDef.field;
  if (fieldname === "WI_WCinKgs" && params.data.WI_WCinKgsNos === "Kgs") {
    params.api.getRowNode(params.node.rowIndex).setDataValue('WI_WCinNos', "");
    return true;
  }
  else if (fieldname === "WI_WCinNos" && params.data.WI_WCinKgsNos === "Nos") {
    return true;
  }
  else return false;
};

const calculateValue = (params) => {
  let calRes;
  if (params.colDef.field === "WI_WMinKgs") {
    calRes = parseFloat(
      params.data.WI_WCinKgs / params.data.WI_CorrectionFactor
    ).toFixed(2);
  }
  return isNaN(calRes) || calRes == Infinity || calRes == undefined
    ? "0"
    : calRes;
};

const calculateValueSet = (params) => {
  let WCinKg = params.newValue;
  let calRes;
  if (
    params.colDef.field === "WI_WCinKgs" &&
    params.data.WI_WCinKgsNos === "Nos"
  ) {
    calRes = parseFloat(
      params.data.WI_WCinNos * params.data.WI_CorrectionFactor
    ).toFixed(2);
  } else {
    calRes = WCinKg;
  }
  return calRes;
};

export default GlobalColumnDefinations;
export { getHeader_FieldName };